import React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/joy';
import JobReviewPanel from './job-records/JobReviewPanel';

const WorkspaceJobRecordDeltaPage: React.FC = () => {
  const { projectId = '' } = useParams<{ projectId: string }>();

  return (
    <Box sx={{ px: { xs: 1, md: 2 }, py: { xs: 1, md: 2 }, width: '100%', maxWidth: 1100, mx: 'auto', boxSizing: 'border-box' }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ sm: 'center' }}
        gap={1}
        sx={{ mb: 2 }}
      >
        <Box>
          <Typography level="h3">Job Record</Typography>
          <Typography level="body-sm" sx={{ color: 'neutral.500' }}>
            Sold versus implemented. This evaluation does not change the quote or invoice.
          </Typography>
        </Box>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <Button
            variant="outlined"
            component={RouterLink}
            to="/workspaces/job-records"
            sx={{ minHeight: 44 }}
          >
            Back to Job Records
          </Button>
          {projectId && (
            <Button
              variant="plain"
              component={RouterLink}
              to={`/projects/${encodeURIComponent(projectId)}/workspace/aftercare`}
              sx={{ minHeight: 44 }}
            >
              Open Aftercare
            </Button>
          )}
        </Stack>
      </Stack>
      {projectId ? <JobReviewPanel projectId={projectId} /> : (
        <Typography level="body-sm">Job not found.</Typography>
      )}
    </Box>
  );
};

export default WorkspaceJobRecordDeltaPage;
